import { isExternal, isInternal, isSIP } from '@pbx/helpers/contact-methods';

function getName(item) {
  if (item.internal_number_id) {
    const internal_number = item.internal_number;
    return `${item.login} (${internal_number.number})`;
  }

  return item.login;
}

function getNumber(item) {
  if (item.number_value) {
    return item.number_value;
  }

  if (item.internal_number_id) {
    return item.internal_number.number;
  }

  return item.login;
}

function getType(item) {
  const backed_types = {
    contact_external_number: 'external',
    sip_account: 'sip',
    number: 'internal'
  };

  if (item.type) {
    return backed_types[item.type];
  } else if (isInternal(item)) {
    return 'internal';
  } else if (isSIP(item)) {
    return 'sip';
  } else if (isExternal(item)) {
    return 'external';
  }

  return '';
}

export const ContactMethodFormatter = {
  formatItem: function(item) {
    const format_name = getName(item);
    const format_number = getNumber(item);
    const format_type = getType(item);

    return { ...item, format_name, format_number, format_type };
  },

  formatItems: function(items = []) {
    return items.map(item => ContactMethodFormatter.formatItem(item));
  }
};
